import {useEffect,useState} from 'react';
import {bundledRelease,latestRelease} from './appRelease';

export function AppInstallHelp(){
  const [release,setRelease]=useState(bundledRelease);
  useEffect(()=>{let stopped=false;void latestRelease().then(value=>{if(!stopped)setRelease(value);});return()=>{stopped=true;};},[]);
  return <div className="chat-app-install-help">
    <p>Если приложение ещё не установлено, скачайте и установите его, затем снова выберите «Открыть чат в приложении».</p>
    <a className="chat-app-download" href={release.url}>Скачать для Windows · {release.version}</a>
    <p>Уже установлено? Подтвердите запрос браузера на открытие приложения и повторите попытку.</p>
  </div>;
}
